import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {RoleService} from '../../../services/role.service';
import {GpsLoadResponseHistoryService} from '../../services/gps-load-response-history.service';
import {MatTableGeneratorComponent} from '../../../shared/mat-table-generator/mat-table-generator.component';
import {MultiCrudDataSource} from '../../../table-datasouces/multi-crud.datasource';
import {BankTransferLoad} from '../../../dto/bankTransferLoad';
import {toDateString, toDateTimeStringNoSeconds} from '../../../providers/app-date-adapter';
import {Location} from '@angular/common';
import {AppMatCustomAction} from '../../../shared/mat-table-generator/mat-table-core/app-mat-custom-action';
import {WebIdTransactionPep} from '../../../dto/web-id-transaction-pep';
import {Invoice} from '../../../dto/invoice';
import {CompanyService} from '../../services/company.service';
import {Company} from '../../../dto/company';




@Component( {
  selector: 'app-gps-history',
  templateUrl: './gps-history.component.html',
  styleUrls: [ './gps-history.component.css' ],
} )
export class GpsHistoryComponent {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private changeDetectorRefs: ChangeDetectorRef,
    private gpsLoadResponseHistoryService: GpsLoadResponseHistoryService,
    private companiesService: CompanyService,
    private location: Location,
  ) { }

  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;

  public companies: Company[] = [];

  ngOnInit() {
    this.table.filters.str = this.route.snapshot.queryParamMap.get( 'search' );
    this.loadCompanies();
  }

  currentUserIsPartner(): boolean {
    return this.roleService.hasRoles(['partner', 'partner_support']);
  }

  private loadCompanies() {
    this.companiesService.getAll().subscribe(x => {
      this.companies = x.data;
    });
  }

  getViewLink = (item: BankTransferLoad): string => '/loads/btl/' + item.id.toString();


  dataSource = new MultiCrudDataSource( this.gpsLoadResponseHistoryService );

  columns = [
    { columnDef: 'customer', header: 'Customer', cell: ( row: BankTransferLoad ) => {
      if( row.card.customer != null  ){
        return row.card.customer.firstName + ' ' + row.card.customer.lastName;
      }

      return '';
      } },

    {columnDef: 'loadType', header: 'Type', icon: (row: BankTransferLoad) => row.loadType == 1 ? 'account_balance' : 'assignment_ind', cell: (row: BankTransferLoad) => `${row.loadType == 1 ? 'Bank':'Partner'}`, cellColor: (row: BankTransferLoad) => `${row.loadType == 1 ? 'grey':'blue'}`},
    /*{ columnDef: 'address', header: 'Address', cell: ( row: BankTransferLoad ) => {
        if( row.card.customer != null  ){
          return row.card.customer.address + ', ' + row.card.customer.zipCode + ' ' + row.card.customer.city;
        }

        return '';
      } },*/
    { columnDef: 'token', header: 'Token', cell: ( row: BankTransferLoad ) => `${ row.card.token || '' }` },
    { columnDef: 'createDate', header: 'Created', cell: ( row: BankTransferLoad ) => `${ toDateTimeStringNoSeconds( row.createDate ) || '' }` },
    { columnDef: 'confirmedDate', header: 'Confirmed', cell: ( row: BankTransferLoad ) => `${ toDateTimeStringNoSeconds(row.confirmedDate)|| '' }` },
    //{ columnDef: 'loadDate', header: 'Loaded on', cell: ( row: BankTransferLoad ) => `${ toDateTimeStringNoSeconds( row.loadDate ) || '' }` },
    { columnDef: 'amount', header: 'Amount', cell: ( row: BankTransferLoad ) => {
      let ret = '';
      //if ( row.isInstantLoad )
        //ret += "⚡️ ";
      ret += `${row.amount?.formatMoneyCcy(row.currencyCode) || ''}`;
      return ret;
      }
    },
    { columnDef: 'amountToLoad', header: 'Amount to load', cell: ( row: BankTransferLoad ) => `${ row.amountToLoad?.formatMoneyCcy(row.currencyCode) || '' }` },

  ];

  search( str: string ) {
    this.table.filters.str = str;
    this.onSearch();
  }

  onSearch( isInvalid = false ) {
    if ( !isInvalid ) {
      this.table.applyFilter();
    }
  }

  returnBack() {
    this.router.navigate(['/loads/btl']);
  }

  editEnabled() {
    return this.roleService.hasRoles('admin');
  }

  currentUserIsAdmin(){
    return this.roleService.hasRoles('admin');
  }

  deleteEnabled() {
    return this.roleService.hasRoles('admin');
  }

  multiselectEnabled() {
    return this.roleService.hasRoles( 'admin');
  }




}
